<template>
  <div class="row" style="min-width: 1200px; min-height: 100%;">

    <div class="card q-pa-md">
      <div class="row  q-col-gutter-sm ">

        <div class="col-12">
          <div class="">
            <div class="d-flex justify-content-between">
              <h4 class="mt-0" style="font-size: 26px; font-weight: 300">
                {{ isEdit ? 'Edit Support' : 'Support Detail' }}</h4>
              <div class="d-flex">
                <div @click="closeDialog" class="drawerButtons">
                  <q-btn flat icon="close" round size="small"></q-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-7">
          <template v-if="supportDetail && !isEdit">
            <div class="box p-4 mt-3 position-relative" style="height: auto;">
              <div class="d-flex w-100 justify-content-between mb-3">
                <div>
                  <h4 class="mb-2" style="font-size: 22px; line-height: 20px">
                    {{ supportDetail.title }} <strong>({{ '#' + supportDetail.supportNo }})</strong>
                  </h4>
                </div>
              </div>
              <div class="col-10 p-4">
                <ul style="list-style: none">
                  <div class="d-flex" v-for="(row, rowIndex) in supportDetail.htmlContent" :key="rowIndex">
                    <li class="w-50 mb-3" v-for="(col, colIndex) in row" :key="colIndex">
                      <div class="bankLabel"><label>{{ col.label }}</label></div>
                      <div class="acInfo"><span>{{ col.value }}</span></div>
                    </li>
                  </div>
                </ul>
                <q-card flat bordered>
                  <h6 class="q-ma-sm">Customer Detail</h6>
                  <q-separator/>
                  <ul style="list-style: none" class="q-ma-sm">
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Company Name</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.companyName || '-' }}</span></div>
                      </li>
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Customer Name</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.name || '-' }}</span></div>
                      </li>
                    </div>
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Phone</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.companyPhone || '-' }}</span></div>
                      </li>
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Mobile</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.mobile || '-' }}</span></div>
                      </li>
                    </div>
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Email</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.email || '-' }}</span></div>
                      </li>
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>City / State</label></div>
                        <div class="acInfo"><span>{{ supportDetail.Customer.companyCity || '-' }}
                                                    {{ '/ ' + supportDetail.Customer.companyState || '/-' }}</span>
                        </div>
                      </li>
                    </div>
                  </ul>
                </q-card>
                <q-card flat bordered class="mt-2">
                  <h6 class="q-ma-sm">Partner Detail</h6>
                  <q-separator/>
                  <ul style="list-style: none" class="q-ma-sm">
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Partner Name</label></div>
                        <div class="acInfo"><span>{{ supportDetail.OrderItem.FromOrganization.name || '-' }}</span>
                        </div>
                      </li>
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Partner Code</label></div>
                        <div class="acInfo"><span>{{
                            supportDetail.OrderItem.FromOrganization.partnerCode || '-'
                          }}</span></div>
                      </li>
                    </div>

                    <!-- ----------Static data only for AIPL----------------------------- -->
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>User Name</label></div>
                        <div class="acInfo">
                          <span v-if="supportDetail.OrderItem.FromOrganization.id === Constants.AIPL_ORGID">Upendra Makwana</span>
                          <span v-else>{{
                              supportDetail.OrderItem.FromOrganization.Users.length ?
                                  supportDetail.OrderItem.FromOrganization.Users[0].name : '-'
                            }}</span>
                        </div>
                      </li>
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Mobile</label></div>
                        <div class="acInfo">
                          <span
                              v-if="supportDetail.OrderItem.FromOrganization.id === Constants.AIPL_ORGID">8980012210</span>
                          <span v-else>{{
                              supportDetail.OrderItem.FromOrganization.Users.length ?
                                  supportDetail.OrderItem.FromOrganization.Users[0].mobile : '-'
                            }}</span></div>
                      </li>
                    </div>
                    <div class="d-flex">
                      <li class="w-50 mb-3">
                        <div class="bankLabel"><label>Email</label></div>
                        <div class="acInfo">
                          <span v-if="supportDetail.OrderItem.FromOrganization.id === Constants.AIPL_ORGID">upendra.makwana@amitygroup.in</span>
                          <span v-else>{{
                              supportDetail.OrderItem.FromOrganization.Users.length ?
                                  supportDetail.OrderItem.FromOrganization.Users[0].email : '-'
                            }}</span></div>
                      </li>
                    </div>
                    <!-----------------x----------------x--------------x-------------- -->
                  </ul>
                </q-card>
              </div>
            </div>
          </template>
        </div>
        <div class="col-5 p-4">
          <div class="col-5 text-h6 mb-3">
            <q-icon name="timeline"></q-icon>
            Timeline
          </div>
          <div v-show="supportHistory_loading">
            <q-inner-loading :showing="true" style="top: 500px;width: 430px;height: 50px;left: 700px;">
              <q-spinner-dots size="50px" style="color: #027be3"/>
            </q-inner-loading>
          </div>
          <div class="drag-inner-list" v-if="supportHistory && supportHistory.length">
            <q-timeline color="blue-10" style="font-size: 16px !important;">
              <template v-for="timeline in supportHistory">
                <template v-if="timeline.eventType==='SUPPORT_ADDED'">
                  <q-timeline-entry
                      :subtitle="'Support Created at '+  dateFilterTimeline( timeline.createdOn)+' by '+(timeline.createdByUserName?timeline.createdByUserName:'-')"
                      :title="timeline.createdByUserName?'Support Created By '+timeline.createdByUserName:'Application Created By  -'"
                      icon="create_new_folder"/>
                </template>
                <template v-else-if="timeline.eventType==='STATUS_CHANGE'">
                  <q-timeline-entry
                      :subtitle="'Status Changed at '+  dateFilterTimeline( timeline.updatedOn)+' by '+(timeline.updatedByUserName?timeline.updatedByUserName:'-')"
                      :title="statusIdToValue[timeline.oldObject.status]+ ' to ' + statusIdToValue[timeline.newObject.status]"
                      icon="turned_in"/>
                </template>
                <template v-else-if="timeline.eventType==='COMMENT_ADDED'">
                  <q-timeline-entry
                      :subtitle="'Comment added at '+  dateFilterTimeline( timeline.createdOn)"
                      :title="timeline.newObject.comment"
                      icon="turned_in"/>
                </template>
                <template v-else-if="timeline.eventType='OTHER_CHANGES'">
                  <template v-for="timeLine in timeline.difference"
                            v-if="!['updated_at','isSupportPlanActive'].includes(timeLine.key)">
                    <q-timeline-entry
                        :subtitle="timeLine.key +' Added at '+dateFilterTimeline( timeline.createdOn)+' by '+(timeline.createdByUserName?timeline.createdByUserName:'-')"
                        :title="timeLine.newDisplayValue.toString()"
                        icon="track_changes"
                        v-if="!timeLine.oldValue"/>
                    <q-timeline-entry
                        :subtitle="timeLine.key +' Added at '+dateFilterTimeline( timeline.createdOn)+' by '+(timeline.createdByUserName?timeline.createdByUserName:'-')"
                        :title="timeLine.oldDisplayValue.toString()"
                        icon="track_changes"
                        v-else-if="!timeLine.newValue"/>
                    <q-timeline-entry
                        :subtitle="timeLine.key +' Changed at '+dateFilterTimeline( timeline.updatedOn)+' by '+(timeline.updatedByUserName?timeline.updatedByUserName:'-')"
                        :title="$data[timeLine.key+'IdToValue'][timeLine.oldDisplayValue]+' to ' +$data[timeLine.key+'IdToValue'][timeLine.newDisplayValue]"
                        icon="track_changes"
                        v-else-if="['source','category'].includes(timeLine.key)"/>
                    <q-timeline-entry
                        :subtitle="timeLine.key +' Changed at '+dateFilterTimeline( timeline.updatedOn)+' by '+(timeline.updatedByUserName?timeline.updatedByUserName:'-')"
                        :title="timeLine.oldDisplayValue+' to ' +timeLine.newDisplayValue"
                        icon="track_changes"
                        v-else/>
                  </template>
                </template>
              </template>
            </q-timeline>
          </div>
          <div v-else>
            No History Available.
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { GET_SUPPORT_CATEGORY, GET_SUPPORT_SOURCES, GET_SUPPORT_STATUSES } from '@/graphql/queries/support'
import Constants from '@/Constants/Constant'
import moment from 'moment'
import { SUBSCRIBE_SUPPORT_HISTORY, SUBSCRIBE_SUPPORT_ID } from '@/graphql/subscription/support'

export default {
  name: 'SupportDetail',
  props: ['supportId'],
  apollo: {
    supportSources: {
      query: GET_SUPPORT_SOURCES,
      result ({ data }) { data.supportSources.forEach(s => this.sourceIdToValue[s.id] = s.name) },
    },
    supportCategory: {
      query: GET_SUPPORT_CATEGORY,
      result ({ data }) { data.supportCategory.forEach(s => this.categoryIdToValue[s.id] = s.name) },
    },
    supportStatuses: {
      query: GET_SUPPORT_STATUSES,
      result ({ data }) {data.supportStatuses.forEach(s => this.statusIdToValue[s.id] = s.name)},
    },
    $subscribe: {
      Supports: {
        query: SUBSCRIBE_SUPPORT_ID,
        variables () { return { id: this.supportId } },
        result ({ data }) {
          this.status = data.Supports[0].Status.id
          this.supportDetail = data.Supports[0]
          this.prepareSupportDetailHtmlContent()
          this.loading = false
        },
      },
      SupportHistory: {
        query: SUBSCRIBE_SUPPORT_HISTORY,
        variables () { return { supportId: this.supportId } },
        result ({ data }) {
          this.supportHistory = data.SupportHistory
          this.supportHistory_loading = false
        },
      },
    },
  },
  data () {
    return {
      Constants: Constants,
      isEdit: false,
      supportStatuses: [],
      status: '',
      formComment: '',
      formSolution: '',
      supportDetail: null,
      loading: false,
      supportHistory: [],
      supportHistory_loading: true,
      statusIdToValue: {},
      categoryIdToValue: {},     //key 'category'
      sourceIdToValue: {},       //key 'source'
    }
  },
  methods: {
    onStatusChange (value) {
      let solutionEle = document.getElementById('solution-field')
      if ([Constants.SupportStatuses.Solved, Constants.SupportStatuses.Rejected].includes(value))
        solutionEle.style.cssText = 'visibility:visible;height: 100px;margin-bottom:30px'
      else
        solutionEle.style.cssText = 'visibility:hidden;height: 0px;margin-bottom:0px'
    },
    closeDialog () {
      this.$emit('closeSupportDetailDialog', false)
    },
    prepareSupportDetailHtmlContent () {
      let a = this.supportDetail
      this.supportDetail.htmlContent = [
        [
          { label: 'Serial Number', value: a.serialNo },
          {
            label: 'Product OEM / ProductLine / Model',
            value: a.Product?.OEM.name + '/' + a.Product?.ProductLine.name + '/' + a.Product?.name,
          }],
        [{ label: 'Source', value: a.Source?.name }, { label: 'Priority', value: a.priority || '-' }],
        [{ label: 'Level', value: a.level || '-' }, { label: 'Reference', value: a.reference || '-' }],
        [{ label: 'Support Plan', value: a.SupportPlan?.name }, { label: 'Assign To', value: a.AssignTo?.name }],
        [{ label: 'Category', value: a.Category?.name || '-' }, { label: 'Created By', value: a.CreatedBy?.name }],
        [{ label: 'Description', value: a.note }],
      ]
      if ([Constants.SupportStatuses.Solved, Constants.SupportStatuses.Rejected].includes(
          this.supportDetail.Status.id)) {
        this.supportDetail.htmlContent.push([{ label: 'Solution', value: a.solution || '-' }])
      }
    },
    dateFilterTimeline (val) {
      return val ? moment(val).format('DD/MM/YYYY hh:mm A') : '-'
    },
  },
}
</script>

<style scoped>
#solution-field {
  height: 0;
  visibility: hidden;
  transition: height 500ms ease;
}

.card {
  width: 100%;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: bottom;
  border-radius: 4px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  position: relative;
}

.w-33 {
  width: 33%;
}
</style>
